module.exports = __webpack_public_path__ + "img/hero_xl.6f659bf.webp";